import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Transacao from "model/suprimentos/Transacao";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class TransacaoService implements BaseServiceCadastros<Transacao> {

    getAll() {
        return new Promise<Transacao[]>((resolve, reject): void => {
            api
                .get(`/transacao/getAll`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/transacao/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: string | number) {
        return new Promise<Transacao>((resolve, reject): void => {
            api
                .get(`/transacao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(transacao: Transacao) {
        return new Promise<Transacao>((resolve, reject): void => {
            let url = `/transacao/incluir`;
            api
                .post(url, JSON.stringify(transacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(transacao: Transacao) {
        return new Promise<Transacao>((resolve, reject): void => {
            api
                .put(`/transacao/editar`, JSON.stringify(transacao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: string | number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/transacao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposTransacao() {
        return [
            { label: 'Entrada', value: 'ENTRADA' }, 
            { label: 'Saída', value: 'SAIDA' }
        ]
    }

    getTipoTransacao(tipo: string) {
        if (tipo === 'ENTRADA') {
            return 'Entrada';
        } else if (tipo === 'SAIDA') {
            return 'Saída';
        }
        return '';
    }

    getTipoTransacaoFilter() {
        return [
            { label: 'Entrada', value: 'E' },
            { label: 'Saida', value: 'S' },

        ]
    }

}

export default TransacaoService;
